import React, { useState } from "react";
import "./shapeCreation.scss";
import MuiRadio from "../radio/MuiRadio";
import { FileUploadIcon } from "../../icons/svg";
import { Button, Checkbox, FormLabel } from "@mui/material";
import InputTextField from "../textField/InputTextField";

const ShapeCreationRadio = ({
  measurement,
  options,
  onChange,
  fileChange,
  fileName,
  defaultValue,
  error,
  scanFileNameChange,
  scanFileName,
  castValue,
  castShipChange,
  removeFile,
  addExistingFile,
}) => {
  const fromCADFileIds = 101;
  const [selectedOption, setSelectedOption] = useState("");

  const handleRadioChange = (event) => {
    setSelectedOption(event.target.value);
    if (fromCADFileIds !== parseInt(event.target.value)) {
      if (removeFile !== undefined) {
        removeFile();
      }
    } else {
      if (addExistingFile !== undefined) {
        addExistingFile();
      }
    }

    if (onChange) {
      onChange(event);
    }
  };

  const shapeCreationContent = [
    {
      name: "From Cast",
      content: (
        <div className="measureCheck">
          <Checkbox checked={castValue} onChange={castShipChange} />
          <FormLabel>Cast Shipped Separately</FormLabel>
        </div>
      ),
    },

    {
      name: "From Measurement",
      content: <div>""</div>,
    },

    {
      name: "From App Scan",
      content: (
        <div className="measureRadio">
          <InputTextField
            label="Scan File Name"
            onChange={scanFileNameChange}
            value={scanFileName}
          />
        </div>
      ),
    },

    {
      name: "From CAD File",
      content: (
        <div className="fileUpload">
          <span>File size must be less than 8 MB</span>
          <Button
            component="label"
            variant="contained"
            startIcon={<FileUploadIcon />}
          >
            Upload File
            <input
              type="file"
              style={{ display: "none" }}
              onChange={fileChange}
            />
          </Button>
          <span>{fileName}</span>
        </div>
      ),
    },
  ];

  const shapeCreationOptions = options.map((option) => ({
    displayName: option.displayName,
    id: option.id,
    content: shapeCreationContent.find(
      (cont) => cont.name === option.displayName
    )?.content,
  }));

  return (
    <>
      <div className="radioContentDisplay shapeCreation">
        <MuiRadio
          options={shapeCreationOptions}
          label="Shape Creation"
          onChange={handleRadioChange}
          required={true}
          error={error}
          defaultValue={defaultValue ?? ""}
        />
      </div>

      <div>
        {(selectedOption === "99" || defaultValue === 99) && (
          <div className="measurementBorder">{measurement}</div>
        )}
      </div>
    </>
  );
};

export default ShapeCreationRadio;
